
import { mapState } from 'vuex';
import AppGradationIcon from '@/components/core/AppGradationIcon';

export default {
  name: 'AppAiIcon',
  components: {
    AppGradationIcon
  },
  props: {
    iconName: {
      type: String,
      default: null,
      validator: v => ['icon-ai-gradation', 'icon-ai-solid'].includes(v)
    },
    iconSize: {
      type: Number,
      default: 16
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings'])
  }
};
